import type { SignInContext } from './users/login'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router'
import App from './App.tsx'
import { logger } from './common/logger.ts'

import { errorPageTexts } from './common/texts.ts'
import { ErrorBoundary } from './components/Common/ErrorBoundary.tsx'
import { ErrorPage } from './pages/ErrorPage.tsx'
import msalSignIn from './users/login'
import './styles/global.css'

msalSignIn().then((signInContext: SignInContext) => {
  const entryPoint = document.getElementById('root') || document.body

  ReactDOM.createRoot(entryPoint).render(
    <React.StrictMode>
      <BrowserRouter>
        <ErrorBoundary fallback={<ErrorPage />}>
          <App pca={signInContext.msalInstance} />
        </ErrorBoundary>
      </BrowserRouter>
    </React.StrictMode>,
  )
}).catch((error: Error) => {
  logger.logError(error)
  logger.logInfo(`App initialization failed, rendering simple html error. Error: ${error?.message}`)
  const entryPoint = document.getElementById('root') || document.body
  entryPoint.innerHTML = `<div style="margin-left: 20px;"><h1>${errorPageTexts.title}</h1><p>${errorPageTexts.message}</p></div>`
})

export { useEnv } from './environment/useEnv.tsx'
